import { render, staticRenderFns } from "./rejectReason.vue?vue&type=template&id=09a9a776&scoped=true"
import script from "./rejectReason.vue?vue&type=script&lang=js"
export * from "./rejectReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a9a776",
  null
  
)

export default component.exports